import { render, staticRenderFns } from "./organization-risk-detail.vue?vue&type=template&id=edb634e0&scoped=true"
import script from "./organization-risk-detail.vue?vue&type=script&lang=js"
export * from "./organization-risk-detail.vue?vue&type=script&lang=js"
import style0 from "./organization-risk-detail.vue?vue&type=style&index=0&id=edb634e0&prod&lang=scss&scoped=true"
import style1 from "./organization-risk-detail.vue?vue&type=style&index=1&id=edb634e0&prod&scoped=true&lang=css"
import style2 from "./organization-risk-detail.vue?vue&type=style&index=2&id=edb634e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb634e0",
  null
  
)

export default component.exports